import type { Network, NetworkInfo } from './network';

export type NetworksConfig = Record<
  Network,
  {
    networkInfo: NetworkInfo;
  }
>;
let config: NetworksConfig | undefined;

const setConfig = (cfg: NetworksConfig): void => {
  config = cfg;
};

const getConfig = (): NetworksConfig | undefined => {
  return config;
};

export { setConfig, getConfig };
